(function() {
  if (window.__wkFx) return;
  window.__wkFx = true;

  if (!document.documentElement.classList.contains('wk-pdp-on')) return;

  var cfg = document.getElementById('wk-pdp-config');
  function on(name) {
    return !cfg || cfg.dataset[name] !== 'false';
  }

  var wrap = document.querySelector('[id^="MainProduct-"]');
  var product = wrap && wrap.querySelector(':scope > .product');
  if (!wrap || !product) return;

  var lang = (document.documentElement.lang || 'en').slice(0, 2);

  // A) Paleta
  if (document.documentElement.classList.contains('wk-color')) {
    try {
      function hexToRgb(hex) {
        hex = hex.replace('#', '');
        if (hex.length === 3) hex = hex.split('').map(function (c) { return c + c; }).join('');
        var n = parseInt(hex.slice(0, 6), 16);
        return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
      }

      function rgbToHsl(r, g, b) {
        r /= 255;
        g /= 255;
        b /= 255;
        var max = Math.max(r, g, b), min = Math.min(r, g, b), h = 0, s = 0, l = (max + min) / 2;
        if (max !== min) {
          var d = max - min;
          s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
          if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
          else if (max === g) h = (b - r) / d + 2;
          else h = (r - g) / d + 4;
          h *= 60;
        }
        return [h, s, l];
      }

      function hslToRgb(h, s, l) {
        var c = (1 - Math.abs(2 * l - 1)) * s, x = c * (1 - Math.abs((h / 60) % 2 - 1)), m = l - c / 2, r = 0, g = 0, b = 0;
        if (h < 60) { r = c; g = x; }
        else if (h < 120) { r = x; g = c; }
        else if (h < 180) { g = c; b = x; }
        else if (h < 240) { g = x; b = c; }
        else if (h < 300) { r = x; b = c; }
        else { r = c; b = x; }
        return [Math.round((r + m) * 255), Math.round((g + m) * 255), Math.round((b + m) * 255)];
      }

      function paletteFrom(rgb) {
        var hsl = rgbToHsl(rgb[0], rgb[1], rgb[2]);
        var h = hsl[0], s = hsl[1];
        var neutral = s < 0.08;
        var sd = neutral ? 0 : Math.min(Math.max(s, 0.25), 0.6);
        return {
          deep: hslToRgb(h, sd * 0.9, 0.17),
          deep2: hslToRgb(h, sd * 0.9, 0.23),
          pale: hslToRgb(h, neutral ? 0 : 0.35, 0.94),
          tile: hslToRgb(h, neutral ? 0 : 0.3, 0.9)
        };
      }

      function applyPalette(p) {
        var st = document.documentElement.style;
        st.setProperty('--wk-deep-rgb', p.deep.join(', '));
        st.setProperty('--wk-deep2-rgb', p.deep2.join(', '));
        st.setProperty('--wk-pale-rgb', p.pale.join(', '));
        st.setProperty('--wk-tile-rgb', p.tile.join(', '));
      }

      function swatchLabel() {
        var vr = product.querySelector('variant-radios');
        if (!vr) return null;
        // El primer radio marcado es la talla; hay que buscar el de color
        var checked = Array.prototype.slice.call(vr.querySelectorAll('input[type="radio"]:checked')).find(function (i) {
          return i.nextElementSibling && i.nextElementSibling.classList.contains('swatch-color');
        });
        return checked ? checked.nextElementSibling : null;
      }

      function swatchHex(label) {
        var name = null;
        for (var i = 0; i < label.classList.length; i++) {
          var cls = label.classList[i];
          if (cls.startsWith('swatch-') && cls !== 'swatch-color') {
            name = cls;
            break;
          }
        }
        if (!name) return null;
        var escaped = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        var styles = document.querySelectorAll('style');
        for (var j = 0; j < styles.length; j++) {
          var text = styles[j].textContent;
          var regex = new RegExp('\\.' + escaped + '\\s*\\{[^}]*?background-color:\\s*(#[0-9a-fA-F]{3,8})');
          var match = text.match(regex);
          if (match) return match[1];
        }
        return null;
      }

      function swatchAverage(label, cb) {
        var bgImage = window.getComputedStyle(label).backgroundImage;
        if (!bgImage || bgImage === 'none') return;
        var match = bgImage.match(/url\(['"]?([^'"]+)['"]?\)/);
        if (!match) return;
        var url = match[1];
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function() {
          try {
            var canvas = document.createElement('canvas');
            canvas.width = 8;
            canvas.height = 8;
            var ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, 8, 8);
            var data = ctx.getImageData(0, 0, 8, 8).data;
            var r = 0, g = 0, b = 0, count = 0;
            for (var i = 0; i < data.length; i += 4) {
              if (data[i + 3] > 0) {
                r += data[i];
                g += data[i + 1];
                b += data[i + 2];
                count++;
              }
            }
            if (count > 0) {
              cb([Math.round(r / count), Math.round(g / count), Math.round(b / count)]);
            }
          } catch (e) {}
        };
        img.onerror = function() {};
        img.src = url;
      }

      function updatePalette() {
        var label = swatchLabel();
        if (!label) return;
        var hex = swatchHex(label);
        if (hex) {
          applyPalette(paletteFrom(hexToRgb(hex)));
        } else {
          swatchAverage(label, function (rgb) {
            applyPalette(paletteFrom(rgb));
          });
        }
      }

      updatePalette();
      var vr = product.querySelector('variant-radios');
      if (vr) {
        vr.addEventListener('change', function() {
          setTimeout(updatePalette, 60);
        });
      }
    } catch (e) {}
  }

  // B) Nombre gigante
  if (on('bigTitle')) {
    try {
      var titleEl = product.querySelector('.product__title h1');
      var text = titleEl ? titleEl.textContent.trim() : '';

      function make(mod) {
        var div = document.createElement('div');
        div.className = 'wk-bigtitle wk-bigtitle--' + mod;
        div.setAttribute('aria-hidden', 'true');
        var track = document.createElement('div');
        track.className = 'wk-bigtitle__track';
        for (var i = 0; i < 2; i++) {
          var span = document.createElement('span');
          span.textContent = text + ' · ';
          track.appendChild(span);
        }
        div.appendChild(track);
        return div;
      }

      if (text) {
        product.parentNode.insertBefore(make('d'), product);
        var mediaWrapper = product.querySelector('.product__media-wrapper');
        if (mediaWrapper) {
          mediaWrapper.insertAdjacentElement('afterend', make('m'));
        }
      }
    } catch (e) {}
  }

  // C) Giro 3D
  if (on('flip')) {
    try {
      var texts = {
        es: { aria: 'Girar la prenda', hint: 'Arrastra para darle la vuelta', btn: 'Dale la vuelta' },
        en: { aria: 'Turn the garment', hint: 'Drag to flip it', btn: 'Flip it' },
        fr: { aria: 'Retourner le vêtement', hint: 'Fais glisser pour le retourner', btn: 'Retourne-le' },
        de: { aria: 'Kleidungsstück drehen', hint: 'Ziehen zum Umdrehen', btn: 'Umdrehen' },
        it: { aria: 'Gira il capo', hint: 'Trascina per girarlo', btn: 'Giralo' },
        pt: { aria: 'Virar a peça', hint: 'Arrasta para a virar', btn: 'Vira-a' },
        nl: { aria: 'Kledingstuk draaien', hint: 'Sleep om te draaien', btn: 'Draai om' }
      };
      var t = texts[lang] || texts.en;

      var items = product.querySelectorAll('media-gallery .product__media-list > li.product__media-item');

      // En móvil la galería de ordenador está oculta y sus imágenes no cargan:
      // se analiza una copia pequeña descargada aparte
      function sizedSrc(img, width) {
        var raw = img.getAttribute('src') || img.currentSrc || '';
        if (!raw) return '';
        var u = new URL(raw, location.href);
        u.searchParams.set('width', String(width));
        return u.toString();
      }

      function isFlat(src) {
        return new Promise(function (resolve) {
          if (!src) return resolve(false);
          var probe = new Image();
          probe.onload = function () {
            try {
              var canvas = document.createElement('canvas');
              canvas.width = 16;
              canvas.height = 16;
              var ctx = canvas.getContext('2d');
              ctx.drawImage(probe, 0, 0, 16, 16);
              var data = ctx.getImageData(0, 0, 16, 16).data;
              resolve([0, 60, 960, 1020].every(function (k) {
                return data[k] >= 244 && data[k + 1] >= 244 && data[k + 2] >= 244;
              }));
            } catch (e) { resolve(false); }
          };
          probe.onerror = function () { resolve(false); };
          probe.src = src;
        });
      }

      // Se rehace al cambiar de color: Dawn sube las fotos de la variante elegida
      var flipRun = 0;
      function initFlip() {
        var run = ++flipRun;
        Array.prototype.forEach.call(product.querySelectorAll('.wk-flip'), function (n) { n.remove(); });
        Array.prototype.forEach.call(product.querySelectorAll('.wk-has-flip'), function (n) { n.classList.remove('wk-has-flip'); });
        items = product.querySelectorAll('media-gallery .product__media-list > li.product__media-item');

        var cand = Array.prototype.slice.call(items, 0, 4).map(function (li) {
          var img = li.querySelector('img');
          return { li: li, probe: img ? sizedSrc(img, 120) : '', full: img ? sizedSrc(img, 1400) : '' };
        });

        Promise.all(cand.map(function (c) { return isFlat(c.probe); })).then(function (flags) {
          if (run !== flipRun) return;
          var flat = cand.filter(function (c, i) { return flags[i]; });
          if (flat.length < 2) return;

          var liA = flat[0].li;
          var srcA = flat[0].full;
          var srcB = flat[1].full;

          function build(mediaBox, mobile) {
            var flip = document.createElement('div');
            flip.className = 'wk-flip';
            flip.setAttribute('role', 'button');
            flip.setAttribute('tabindex', '0');
            flip.setAttribute('aria-label', t.aria);

            var card = document.createElement('div');
            card.className = 'wk-flip__card';

            var faceA = document.createElement('div');
            faceA.className = 'wk-flip__face wk-flip__face--a';
            var imgElemA = document.createElement('img');
            imgElemA.alt = '';
            imgElemA.src = srcA;
            faceA.appendChild(imgElemA);

            var faceB = document.createElement('div');
            faceB.className = 'wk-flip__face wk-flip__face--b';
            var imgElemB = document.createElement('img');
            imgElemB.alt = '';
            imgElemB.src = srcB;
            faceB.appendChild(imgElemB);

            card.appendChild(faceA);
            card.appendChild(faceB);
            flip.appendChild(card);

            var hint = document.createElement('span');
            hint.className = 'wk-flip__hint';
            hint.textContent = t.hint;
            flip.appendChild(hint);

            if (mobile) {
              var btn = document.createElement('button');
              btn.type = 'button';
              btn.className = 'wk-flip__btn';
              btn.textContent = t.btn;
              flip.appendChild(btn);
            }

            mediaBox.classList.add('wk-has-flip');
            mediaBox.appendChild(flip);

            var angle = 0;
            var state = {
              x0: 0, a0: 0, moved: false, skipNext: false, pointerId: null
            };

            function setAngle(a, animate) {
              if (!animate) flip.classList.add('is-dragging');
              else flip.classList.remove('is-dragging');
              card.style.transform = 'rotateY(' + a + 'deg)';
            }

            if (!mobile) {
              flip.addEventListener('pointerdown', function(e) {
                state.x0 = e.clientX;
                state.a0 = angle;
                state.moved = false;
                state.pointerId = e.pointerId;
                flip.setPointerCapture(e.pointerId);
              });

              flip.addEventListener('pointermove', function(e) {
                if (!flip.hasPointerCapture(e.pointerId)) return;
                var dx = e.clientX - state.x0;
                if (Math.abs(dx) > 4) state.moved = true;
                if (state.moved) {
                  setAngle(state.a0 + dx * 0.6, false);
                }
              });

              flip.addEventListener('pointerup', function(e) {
                if (!state.moved) {
                  angle = state.a0 + 180;
                } else {
                  angle = Math.round((state.a0 + (e.clientX - state.x0) * 0.6) / 180) * 180;
                }
                setAngle(angle, true);
                flip.classList.add('is-used');
              });

              flip.addEventListener('pointercancel', function(e) {
                angle = Math.round((state.a0 + (e.clientX - state.x0) * 0.6) / 180) * 180;
                setAngle(angle, true);
                flip.classList.add('is-used');
              });

              flip.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
              });

              flip.addEventListener('keydown', function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  angle += 180;
                  setAngle(angle, true);
                  flip.classList.add('is-used');
                }
              });

              var observer = new IntersectionObserver(function(entries) {
                if (entries[0].isIntersecting) {
                  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                    setAngle(28, true);
                    setTimeout(function() { setAngle(0, true); }, 600);
                  }
                  observer.disconnect();
                }
              }, { threshold: 0.6 });
              observer.observe(flip);
            } else {
              if (btn) {
                btn.addEventListener('click', function(e) {
                  e.preventDefault();
                  e.stopPropagation();
                  angle += 180;
                  setAngle(angle, true);
                });
              }

              flip.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
              });
            }
          }

          var mediaBoxD = liA.querySelector('.product__media');
          if (mediaBoxD) build(mediaBoxD, false);

          var swiper = product.querySelector('.swiper-product');
          if (swiper) {
            var slides = swiper.querySelectorAll('.swiper-slide');
            for (var i = 0; i < slides.length; i++) {
              if (slides[i].id === liA.id) {
                var mediaBoxM = slides[i].querySelector('.product__media');
                if (mediaBoxM) build(mediaBoxM, true);
                break;
              }
            }
          }
        });
      }

      initFlip();
      var vrFlip = product.querySelector('variant-radios');
      if (vrFlip) {
        vrFlip.addEventListener('change', function () { setTimeout(initFlip, 400); });
      }
    } catch (e) {}
  }

  // D) Hojas
  if (on('leaves')) {
    try {
      var leafTexts = {
        es: '+1 árbol con tu pedido',
        en: '+1 tree with your order',
        fr: '+1 arbre avec ta commande',
        de: '+1 Baum mit deiner Bestellung',
        it: '+1 albero con il tuo ordine',
        pt: '+1 árvore com a tua encomenda',
        nl: '+1 boom met je bestelling'
      };
      var leafText = leafTexts[lang] || leafTexts.en;

      function burst(el) {
        var r = el.getBoundingClientRect();
        var cx = r.left + r.width / 2;
        var cy = r.top + r.height / 2;

        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          var colors = ['#97C459', '#639922', '#C0DD97', '#3B6D11'];
          for (var i = 0; i < 12; i++) {
            var leaf = document.createElement('div');
            leaf.className = 'wk-leaf';
            leaf.style.left = cx + 'px';
            leaf.style.top = cy + 'px';
            leaf.style.background = colors[Math.floor(Math.random() * colors.length)];
            document.body.appendChild(leaf);

            var dx = Math.random() * 280 - 140;
            var dy = Math.random() * 140 - 190;
            var rot = Math.random() * 440 - 220;
            var dur = 900 + Math.random() * 500;

            var anim = leaf.animate(
              [
                { transform: 'translate(0,0) rotate(0deg)', opacity: 1 },
                { transform: 'translate(' + dx + 'px,' + dy + 'px) rotate(' + rot + 'deg)', opacity: 0 }
              ],
              { duration: dur, easing: 'cubic-bezier(.2,.8,.2,1)', fill: 'forwards' }
            );
            // Cada hoja se borra a sí misma (con var, todas apuntarían a la última)
            anim.onfinish = (function (node) { return function () { node.remove(); }; })(leaf);
          }
        }

        var toast = document.createElement('div');
        toast.className = 'wk-tree-toast';
        toast.textContent = leafText;
        toast.style.left = cx + 'px';
        if (r.top < 90) {
          toast.classList.add('is-below');
          toast.style.top = (r.bottom + 10) + 'px';
        } else {
          toast.style.top = (r.top - 10) + 'px';
        }
        document.body.appendChild(toast);

        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            toast.classList.add('is-on');
          });
        });

        setTimeout(function() { toast.classList.remove('is-on'); }, 2200);
        setTimeout(function() { toast.remove(); }, 2600);
      }

      var skipNext = false;
      document.addEventListener('click', function(e) {
        var stickyBtn = e.target.closest('.wk-sticky-atc__btn');
        if (stickyBtn && !stickyBtn.disabled) {
          burst(stickyBtn);
          skipNext = true;
          return;
        }

        var addBtn = e.target.closest('product-form button[name="add"]');
        if (addBtn && addBtn.closest('[id^="MainProduct-"]')) {
          if (skipNext) {
            skipNext = false;
            return;
          }
          if (addBtn.disabled || addBtn.getAttribute('aria-disabled') === 'true') return;
          burst(addBtn);
        }
      }, true);
    } catch (e) {}
  }

  // E) Barrido de fotos
  if (on('reveal') && window.matchMedia('(min-width: 990px)').matches) {
    try {
      var items = product.querySelectorAll('media-gallery .product__media-list > li.product__media-item');
      for (var i = 1; i < items.length; i++) {
        items[i].classList.add('wk-reveal');
      }

      var revealObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });

      items.forEach(function(item) {
        if (item.classList.contains('wk-reveal')) {
          revealObserver.observe(item);
        }
      });
    } catch (e) {}
  }
})();
